import Vue from "vue";
import Router from "vue-router";

import store from "./store";

// import MainPage from "./views/MainPage/MainPage.vue";
import SpecialPage from "./views/SpecialPage/SpecialPage.vue";
import AboutUs from "./views/AboutUs/AboutUs.vue";
import Contacts from "./views/Contacts/Contacts.vue";
import EventPage from "./views/EventPage/EventPage.vue";

import UserPage from "./views/UserPage/UserPage.vue";
import UserProfile from "./views/UserPage/components/user-profile/user-profile.vue";
import UserRequests from "./views/UserPage/components/user-orders/user-orders.vue";
import UserSettings from "./views/UserPage/components/user-settings/user-settings.vue";
import UserFeedback from "./views/UserPage/components/user-feedback/user-feedback.vue";

import OperatorPage from "./views/OperatorPage/OperatorPage.vue";
import OperatorRequests from "./views/OperatorPage/components/operator-requests/operator-requests.vue";
import OperatorSettings from "./views/OperatorPage/components/operator-settings/operator-settings.vue";
// import OperatorRequestsContests from "./views/OperatorPage/components/operator-requests/operator-requests-contests.vue";
import OperatorRequestsQuota from "./views/OperatorPage/components/operator-requests/operator-requests-quota.vue";
import OperatorCard from "./views/OperatorPage/components/operator-card/operator-card.vue";

import AdminPage from "./views/AdminPage/AdminPage.vue";
import AdminAllRequests from "./views/AdminPage/components/admin-all-requests/admin-all-requests.vue";
import AdminContextRequests from "./views/AdminPage/components/admin-contests-requests/admin-contests-requests.vue";
import AdminQuotaRequests from "./views/AdminPage/components/admin-quota-requests/admin-quota-requests.vue";
import AdminContentManagers from "./views/AdminPage/components/admin-managers/admin-managers.vue";
import AdminOperators from "./views/AdminPage/components/admin-operators/admin-operators.vue";
import AdminPlace from "./views/AdminPage/components/admin-place/admin-place.vue";
import AdminOperatorsCreate from "./views/AdminPage/components/admin-operators-create/admin-operators-create.vue";
import AdminOperatorsEdit from "./views/AdminPage/components/admin-operators-edit/admin-operators-edit.vue";
import AdminManagersCreate from "./views/AdminPage/components/admin-managers-create/admin-managers-create.vue";
import AdminManagersEdit from "./views/AdminPage/components/admin-managers-edit/admin-managers-edit.vue";
import AdminRegistry from "./views/AdminPage/components/admin-registry/admin-registry.vue";

import RequestPage from "./views/RequestPage/RequestPage.vue";

import { RoleEnums } from "./const";

Vue.use(Router);

const checkPermissions = (to, from, next) => {
  if (store.state.isAuthorized) {
    let role = [];
    to.matched.find((record) => {
      if (record.meta.role) {
        role = record.meta.role;
      }
    });
    if (
      role.filter((i) => {
        return store.state.userData.role === i;
      }).length > 0
    ) {
      next();
      return;
    }
  }
  next("/");
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "special-page",
      component: SpecialPage,
    },
    /*{
        path: "/",
        name: "main-page",
        component: MainPage
      },*/
    {
      path: "/about-us",
      name: "about-us",
      component: AboutUs,
    },
    {
      path: "/contacts",
      name: "contacts",
      component: Contacts,
    },
    {
      path: "/event/:eventId",
      name: "event-page",
      component: EventPage,
    },
    {
      path: "/user",
      name: "user-page",
      component: UserPage,
      beforeEnter: checkPermissions,
      meta: { role: [RoleEnums.USER] },
      redirect: "/user/profile",
      children: [
        {
          path: "profile",
          name: "user-profile",
          component: UserProfile,
        },
        {
          path: "requests",
          name: "user-requests",
          component: UserRequests,
        },
        {
          path: "settings",
          name: "user-settings",
          component: UserSettings,
        },
        {
          path: "feedback",
          name: "user-feedback",
          component: UserFeedback,
        },
      ],
    },
    {
      path: "/operator",
      name: "operator-page",
      component: OperatorPage,
      beforeEnter: checkPermissions,
      meta: {
        role: [RoleEnums.OPERATOR, RoleEnums.MODERATOR],
      },
      redirect: "/operator/requests",
      children: [
        {
          path: "requests",
          name: "operator-requests",
          component: OperatorRequests,
          children: [
            {
              path: "/",
              name: "operator-requests-quota",
              component: OperatorRequestsQuota,
            },
            {
              path: ":id",
              name: "operator-card",
              props: true,
              component: OperatorCard,
            },
          ],
        },
        {
          path: "settings",
          name: "operator-settings",
          component: OperatorSettings,
        },
        /*{
          path: "requests-contests",
          name: "operator-requests-contests",
          component: OperatorRequestsContests
        },*/
      ],
    },
    {
      path: "/administrator",
      name: "admin-page",
      component: AdminPage,
      beforeEnter: checkPermissions,
      meta: { role: [RoleEnums.ADMIN] },
      redirect: "/administrator/requests",
      children: [
        {
          path: "contests-requests",
          name: "admin-contests-requests",
          component: AdminContextRequests,
        },
        {
          path: "quota-requests",
          name: "admin-quota-requests",
          component: AdminQuotaRequests,
        },
        {
          path: "requests",
          name: "admin-all-requests",
          component: AdminAllRequests,
        },
        {
          path: "requests/:id",
          name: "request-page",
          props: true,
          component: RequestPage,
        },
        {
          path: "registry",
          name: "admin-registry",
          component: AdminRegistry,
        },

        {
          path: "managers",
          name: "admin-managers",
          component: AdminContentManagers,
        },
        {
          path: "managers-create",
          name: "admin-managers-create",
          component: AdminManagersCreate,
        },
        {
          path: "managers-edit",
          name: "admin-managers-edit",
          component: AdminManagersEdit,
        },
        {
          path: "operators",
          name: "admin-operators",
          component: AdminOperators,
        },
        {
          path: "place",
          name: "admin-place",
          component: AdminPlace,
        },
        {
          path: "operators-create",
          name: "admin-operators-create",
          component: AdminOperatorsCreate,
        },
        {
          path: "operators-edit",
          name: "admin-operators-edit",
          component: AdminOperatorsEdit,
        },
      ],
    },
  ],
});
